import { useEffect, useRef, useState } from "react";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import useCurrency from "helpers/useCurrency";

export interface PriceProps {
  val: number;
  data: TableCol["data"];
  options: any;
  row: any;
  colKey: string;
  onChange: (item: any, options?: any) => void;
  withBorder?: boolean;
  inputProps?: BasicTextInputProps;
  style?: React.CSSProperties;
}
export default function Price(props: PriceProps) {
  const { val, withBorder, options, row, colKey } = props;
  const { defCur } = useCurrency();
  const [value, setValue] = useState(!!val ? val : 0);
  const [count, setCount] = useState(0);
  const ref = useRef<any>(null);
  const editable = options && options.editable;
  const deps: string[] = options?.deps || [];
  let changeOnBlur = true;
  if (options?.changeOnBlur !== undefined) changeOnBlur = !!options?.changeOnBlur;

  useEffect(() => {
    setCount((x) => x + 1);
  }, [...deps.map((x) => row[x])]);

  useEffect(() => setValue(val), [val]);

  let onChange = props.onChange;
  if (options && options.onChange) onChange = options.onChange;
  let currency = defCur.en_title;
  if (options) {
    if (options.currency) currency = options.currency;
    if (options.currencyKey && row[options.currencyKey]) {
      const c = row[options.currencyKey];
      currency = typeof c === "string" ? c : c.label || currency;
    }
  }

  let res = value;
  if (options && options.conditionalVal) {
    res = getVal(options);
  }

  function handleChange(val: number) {
    setValue(val);
    if (!changeOnBlur) {
      let res = { ...row };
      res[colKey] = val;
      onChange(res, { row, options });
    }
  }

  function handleBlur() {
    if (changeOnBlur) {
      let res = { ...row };
      res[colKey] = value;
      onChange(res, { row, options });
    }
  }

  function getVal({ operator, keys }: any) {
    if (operator === "*") {
      return keys.map((key: any) => row[key]).reduce((x: any, i: any) => x * i, 1);
    }
    return 0;
  }

  return (
    <div
      className={`${props?.options?.classes}`}
      style={{ display: "flex", direction: "rtl", gap: "10px", alignItems: "center" }}
      onClick={() => ref.current && ref.current.focus()}
    >
      {!editable ? (
        <div className={`flex gap-2 w-full items-center`}>
          <span className="text-xs text-dark-3">{currency}</span>
          <span className="text-sm font-bold text-dark-1">{Intl.NumberFormat().format(res || 0)}</span>
        </div>
      ) : (
        <>
          <BasicTextInput
            key={count}
            fullWidth
            style={{
              color: "#1A1919",
              ...(!withBorder && { border: "none" }),
              direction: "ltr",
              padding: "0px 8px",
              ...props.style,
            }}
            val={Intl.NumberFormat().format(res || 0)}
            suffix={<span style={{ color: "#828282", fontSize: 14 }}>{currency}</span>}
            type="price"
            onChange={(val) => typeof val === "number" && handleChange(val)}
            onBlur={handleBlur}
            {...props.inputProps}
          />
        </>
      )}
    </div>
  );
}
